<template>
  <section class="booking-wrap">
    <picture v-if=" isZoe && bannerList.length == 0">
      <source
        class="illust"
        media="(max-width: 499px)"
        :srcset="
          bannerMobileImage
            ? bannerMobileImage
            : require(`../../../images/hero_banner_mobile.webp`)
        "
      >
      <source
        class="illust"
        media="(min-width: 500px)"
        :src="
          bannerDesktopImage
            ? bannerDesktopImage
            : require(`../../../images/hero_banner.webp`)
        "
      >
      <img
        class="illust"
        :src="
          bannerDesktopImage
            ? bannerDesktopImage
            : require(`../../../images/hero_banner.webp`)
        "
        alt=""
      >
    </picture>
    <carousel
      v-if="isZoe && bannerList.length > 0"
      :per-page="1"
      :pagination-active-color="'#F45000'"
      :navigation-enabled="true"
      :speed="1000"
      :navigation-next-label="''"
      :navigation-prev-label="''"
    >
      <slide
        v-for="(banner, index) in bannerList"
        :key="index"
      >
        <a
          :href="banner.url"
          :target="banner.target"
        >
          <picture>
            <source

              media="(max-width: 499px)"
              :srcset="banner.medium_mobile_portrait_file.url"
            >
            <source

              media="(min-width: 500px)"
              :src="banner.medium_file.url"
            >
            <img
              class="illust "
              :src="banner.medium_file.url"
              alt=""
            >
          </picture>
        </a>
      </slide>
    </carousel>

    <picture v-if=" !isZoe">
      <source
        class="illust"
        media="(max-width: 499px)"
        srcset="../../../images/hero-zoe-banner-mobile.webp"
      >
      <source
        class="illust"
        media="(min-width: 500px)"
        srcset="../../../images/hero-zoe-banner.webp"
      >
      <img
        class="illust"
        src="../../../images/hero-zoe-banner.webp"
        alt=""
      >
    </picture>
    <mobility-booking />
  </section>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
import MobilityBooking from './MobilityBooking'

export default {
  name: 'MobilityHero',
  components: {
    Carousel,
    Slide,
    MobilityBooking,
  },
  props: {
    isZoe: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {

    }
  },
  computed: {

    bannerUrl() {
      return window.renaultRent.banner_default?.url
    },
    bannerUrlTarget() {
      return window.renaultRent.banner_default?.target
    },
    bannerDesktopImage() {
      /* eslint-disable-next-line camelcase */
      return window.renaultRent.banner_default?.medium_file?.url
    },
    bannerMobileImage() {
      /* eslint-disable-next-line camelcase */
      return window.renaultRent.banner_default?.medium_mobile_portrait_file?.url
    },
    bannerList() {
      /* eslint-disable-next-line camelcase */
      return window.renaultRent?.slider_banners
    },
  },

  methods: {

  },
}
</script>
<style lang="scss">
.VueCarousel-pagination {
  bottom: 0;
  left: 45%;
  position: absolute;
  width: auto !important;
  z-index: 2;

  @media all and (min-width: 60em) {
    left: 50%;
  }
}

.VueCarousel {
  @media all and (min-width: 60em) {
    height: 600px;
  }

  @media all and (min-width: 124em) {
    height: auto;
  }
}

.VueCarousel-slide {
  position: relative;
}

.VueCarousel-navigation-prev {
  display: none;

  @media all and (min-width: 60em) {
    display: block;
    left: 27px !important;
  }

  &::before {
    border: 2px solid white;
    border-width: 0.2rem 2px 0 0;
    content: '';
    display: inline-block;
    height: 1.6em;
    margin-right: -8px;
    transform: rotate(225deg);
    vertical-align: middle;
    width: 1.6em;
  }
}

.VueCarousel-wrapper {
  height: 100%;
}

.VueCarousel-inner {
  min-height: 100%;
}

.VueCarousel-navigation-next {
  display: none;

  @media all and (min-width: 60em) {
    display: block;
    right: 29px !important;
  }

  &::before {
    border: 2px solid white;
    border-width: 2px 2px 0 0;
    content: '';
    display: inline-block;
    height: 1.6em;
    margin-left: -8px;
    transform: rotate(45deg);
    vertical-align: middle;
    width: 1.6em;
  }
}

.VueCarousel-navigation--disabled {
  display: none;
}

.VueCarousel-navigation-button {
  background: linear-gradient(270deg, #000 50%, #000 0);
  background-position: 100% 100%;
  background-size: 200% 100%;
  color: white !important;
  padding: 30px 8px !important;
  transition: background-position 0.3s;
}
</style>

<style scoped lang="scss">
@import '../../../../_src/sass/config/vars';
@import '../../../../_src/sass/config/mixins';
@import '../../../../_src/sass/config/responsive';

.illust {
  aspect-ratio: 375/439;
  display: flex;
  width: 100%;


  @include teq-breakpoint($large) {
    aspect-ratio: 1440/600;
    height: 100%;
    max-height: 600px;
    object-fit: contain;
  }

  @include teq-breakpoint($xxxl) {
    aspect-ratio: 2880/1177;
    max-height: inherit;
  }
}

svg {
  height: 18px;
  width: 18px;
}

.booking-wrap {
  background: #000;
  padding-bottom: 2rem;
  position: relative;
  z-index: 10;

  @include teq-breakpoint($large) {
    padding-bottom: 0;
  }
}

</style>
